{
  "name": "quoting",
  "version": "0.0.0-889b032f.0",
  "private": true,
  "overrides": {
    "picomatch@^4": "4.0.4"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4200",
    "start:dev": "ng serve --configuration development",
    "build": "ng build",
    "analyze-build": "ng build --stats-json && source-map-explorer dist/quoting/browser/**/*.js --no-border-checks",
    "test": "ng test",
    "test:contract": "jest --config=jest.contract.config.js",
    "test:contract:watch": "jest --config=jest.contract.config.js --watch",
    "test:watch": "ng test --watch --code-coverage",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "ci:test": "ng test --watch=false --code-coverage && npm run check-coverage",
    "check-coverage": "node scripts/check-coverage.mjs",
    "ci:e2e": "start-server-and-test start http://localhost:4200 cypress:run",
    "ci:e2e:critical": "start-server-and-test start http://localhost:4200 --timeout 300 'npx cypress-split --ci-build-id $GITHUB_RUN_ID --group critical --spec cypress/e2e/feature-tests/critical-path/**/*.spec.cy.ts'",
    "ci:e2e:forms": "start-server-and-test start http://localhost:4200 --timeout 300 'npx cypress-split --ci-build-id $GITHUB_RUN_ID --group forms --spec cypress/e2e/feature-tests/quote-form-tests/**/*.cy.ts'",
    "ci:e2e:release": "npx cypress-split --ci-build-id $GITHUB_RUN_ID --group release",
    "ci:audit": "npm audit --omit=dev --audit-level=high",
    "ci:build": "ng build",
    "ci:lint": "ng lint",
    "e2e": "ng e2e",
    "cypress:open": "npx cypress open",
    "cypress:run": "npx cypress run",
    "prepare": "husky",
    "precommit": "lint-staged",
    "dd-app-version": "npm --no-git-tag-version version pre --preid=$(git rev-parse --short HEAD)",
    "dd-upload-sourcemaps": "datadog-ci sourcemaps upload dist/quoting/browser --service=quoting-ui --release-version=$VERSION --minified-path-prefix=/ --repository-url=https://github.com/kin/quoting-ui"
  },
  "dependencies": {
    "@angular-architects/ngrx-toolkit": "^20.0.0",
    "@angular/animations": "^20.3.27",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.27",
    "@angular/compiler": "^20.3.27",
    "@angular/core": "^20.3.27",
    "@angular/forms": "^20.3.27",
    "@angular/platform-browser": "^20.3.27",
    "@angular/platform-browser-dynamic": "^20.3.27",
    "@angular/router": "^20.3.27",
    "@datadog/browser-rum": "^5.31.1",
    "@fullstory/browser": "^2.0.8",
    "@kin/css": "^3.10.0",
    "@kin/ngk-auth": "^2.0.1",
    "@kin/ngk-logger": "^3.0.0",
    "@kin/spark-ui": "^1.22.0",
    "@kin/web-components": "^5.12.0",
    "@maskito/angular": "^3.0.1",
    "@maskito/core": "^3.4.0",
    "@maskito/kit": "^3.0.1",
    "@ng-icons/core": "^31.2.0",
    "@ng-icons/lucide": "^31.2.0",
    "@ng-web-apis/common": "^5.1.0",
    "@ngrx/operators": "^20.0.0",
    "@ngrx/signals": "^20.0.0",
    "@splitsoftware/splitio": "^10.25.2",
    "@tailwindcss/container-queries": "^0.1.1",
    "cally": "^0.8.0",
    "date-fns": "^4.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "^20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/build": "^20.3.28",
    "@angular/cli": "^20.3.28",
    "@angular/compiler-cli": "^20.3.27",
    "@babel/preset-typescript": "^7.26.0",
    "@cypress/schematic": "^2.5.2",
    "@datadog/datadog-ci": "^4.2.2",
    "@faker-js/faker": "^9.0.2",
    "@pact-foundation/pact": "^15.0.1",
    "@tailwindcss/postcss": "^4.1.14",
    "@types/jest": "^30.0.0",
    "@types/lodash": "^4.17.6",
    "@types/node-fetch": "^2.6.12",
    "@types/supertest": "^6.0.2",
    "@vitest/coverage-v8": "^3.2.7",
    "axios": "1.13.6",
    "cypress": "^14.5.1",
    "cypress-iframe": "^1.0.1",
    "cypress-mochawesome-reporter": "^3.8.2",
    "cypress-multi-reporters": "^1.6.4",
    "cypress-split": "^1.24.7",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-import-resolver-typescript": "^3.8.7",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prettier": "^5.1.3",
    "eslint-plugin-unused-imports": "^4.1.4",
    "husky": "^9.1.6",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.6.0",
    "jsdom": "^29.1.1",
    "lint-staged": "^15.5.0",
    "mocha-junit-reporter": "^2.2.1",
    "node-fetch": "^3.3.2",
    "postcss": "^8.5.3",
    "prettier": "^3.3.3",
    "prettier-plugin-tailwindcss": "^0.6.14",
    "source-map-explorer": "^2.5.3",
    "start-server-and-test": "^2.0.4",
    "supertest": "^7.0.0",
    "tailwindcss": "^4.1.14",
    "ts-jest": "^29.2.5",
    "typescript": "~5.8.2",
    "typescript-eslint": "^8.56.0",
    "vitest": "^3.2.7"
  },
  "engines": {
    "node": "^20.19.0",
    "npm": "^10.0.0"
  }
}
